import * as React from 'react';
import { useParams } from 'react-router-dom';
import PortContainer from '~/containers/PortContainer/PortContainer';
import { PortPreviewType } from '~/components/Port/settings';

export default function PortRouter() {
    const { id, shipId, exteriorId, portPreviewType } = useParams();
    return <PortContainer match={{ id, shipId: +shipId, exteriorId: +exteriorId, portPreviewType: portPreviewType as PortPreviewType }} />;
}
